import * as React from "react";
import { Formik, Field } from "formik";
import { useTranslation } from "react-i18next";
import { BootstrapModalWrapper, Input, Modal } from "components/bootstrap";
import { FormikInput, ModalSubmit } from "components/common";
import { formHasErrors, getValueFromInput } from "util/FormsUtils";
import FilterRulesFields from "components/streams/StreamDetails/output-filter/FilterRulesFields";
const FilterRuleForm = ({ title, filterRule, onCancel, handleSubmit, destinationType }) => {
  const { t } = useTranslation("streams");
  const validate = (values) => {
    const { title: currentTitle, rule } = values;
    let errors = {};
    if (!currentTitle) {
      errors = { ...errors, title: t("output_filter.form.title_required") };
    }
    if (!(rule == null ? void 0 : rule.conditions) || (rule == null ? void 0 : rule.conditions) && rule.conditions.length <= 0) {
      errors = { ...errors, rule: t("output_filter.form.condition_required") };
    }
    return errors;
  };
  return /* @__PURE__ */ React.createElement(BootstrapModalWrapper, { showModal: true, bsSize: "lg", onHide: onCancel }, /* @__PURE__ */ React.createElement(
    Formik,
    {
      initialValues: {
        ...filterRule,
        destination_type: destinationType,
        ...!(filterRule == null ? void 0 : filterRule.id) && {
          status: "enabled",
          rule: {
            operator: "AND",
            conditions: [],
            actions: []
          }
        }
      },
      validate,
      validateOnBlur: true,
      validateOnChange: true,
      onSubmit: () => {
      }
    },
    ({ isSubmitting, values, isValid, errors, validateForm, setFieldValue }) => {
      var _a, _b;
      const onSubmit = () => {
        validateForm().then((errorsList) => {
          if (!formHasErrors(errorsList)) {
            handleSubmit(values);
          }
        });
      };
      const onStatusChange = (event) => {
        const isChecked = getValueFromInput(event.target);
        setFieldValue("status", isChecked ? "enabled" : "disabled");
      };
      return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Modal.Header, null, /* @__PURE__ */ React.createElement(Modal.Title, null, title)), /* @__PURE__ */ React.createElement(Modal.Body, null, /* @__PURE__ */ React.createElement(
        FormikInput,
        {
          id: "title",
          name: "title",
          label: t("output_filter.form.title"),
          help: t("output_filter.form.title_help"),
          error: errors.title,
          required: true
        }
      ), /* @__PURE__ */ React.createElement(
        FormikInput,
        {
          id: "description",
          name: "description",
          label: t("output_filter.form.description"),
          help: t("output_filter.form.description_help")
        }
      ), /* @__PURE__ */ React.createElement(Field, { name: "status" }, ({ field: { name, value }, meta }) => /* @__PURE__ */ React.createElement(
        Input,
        {
          id: name,
          error: meta == null ? void 0 : meta.error,
          label: t("output_filter.form.enabled"),
          type: "checkbox",
          onChange: onStatusChange,
          checked: value === "enabled",
          value: value === "enabled"
        }
      )), /* @__PURE__ */ React.createElement("label", { htmlFor: "rule_builder" }, t("output_filter.form.rule_builder")), (errors == null ? void 0 : errors.rule) && /* @__PURE__ */ React.createElement("p", { className: "text-danger" }, errors.rule), /* @__PURE__ */ React.createElement(FilterRulesFields, { type: "condition" }), /* @__PURE__ */ React.createElement(Modal.Footer, null, /* @__PURE__ */ React.createElement(
        ModalSubmit,
        {
          isSubmitting,
          isAsyncSubmit: true,
          onSubmit,
          onCancel,
          disabledSubmit: !isValid || ((_b = (_a = values == null ? void 0 : values.rule) == null ? void 0 : _a.errors) == null ? void 0 : _b.length) > 0,
          submitButtonText: (values == null ? void 0 : values.id) ? t("output_filter.form.update") : t("output_filter.form.create"),
          submitLoadingText: (values == null ? void 0 : values.id) ? t("output_filter.form.updating") : t("output_filter.form.saving")
        }
      ))));
    }
  ));
};
export default FilterRuleForm;
